import CryptoJS from 'crypto-js';
import Cookies from "js-cookie";
import { COOKIE_KEY, DECRYPT_KEY } from "../utils/constants/GlobalConstants"

export const getUserRole = () => {
    const encryptF = Cookies.get(COOKIE_KEY);
    const bytes = CryptoJS.AES.decrypt(encryptF, DECRYPT_KEY);
    const decryptData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptData?.group;
};

export const getUserName = () => {
    const encryptF = Cookies.get(COOKIE_KEY);
    const bytes = CryptoJS.AES.decrypt(encryptF, DECRYPT_KEY);
    const decryptData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptData?.name;
}
export const getUserEmail = () => {
    const encryptF = Cookies.get(COOKIE_KEY);
    const bytes = CryptoJS.AES.decrypt(encryptF, DECRYPT_KEY);
    const decryptData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptData?.email;
}